import { createInventoryAdjustmentReason } from "./schema/adjustment-reasons/create-inventory-adjustment-reason";
import { deleteInventoryAdjustmentReason } from "./schema/adjustment-reasons/delete-inventory-adjustment-reason";
import { listInventoryAdjustmentReasons } from "./schema/adjustment-reasons/list-inventory-adjustment-reasons";
import { updateInventoryAdjustmentReason } from "./schema/adjustment-reasons/update-inventory-adjustment-reason";
import { bulkUpdateReservedInventoryBuckets } from "./schema/reserved-inventory-buckets/bulk-update-reserved-inventory-buckets";
import { createCustomReservedInventoryBucketType } from "./schema/reserved-inventory-buckets/create-custom-reserved-inventory-bucket-type";
import { deleteCustomReservedInventoryBucketType } from "./schema/reserved-inventory-buckets/delete-custom-reserved-inventory-bucket-type";
import { getReservedInventoryBuckets } from "./schema/reserved-inventory-buckets/get-reserved-inventory-buckets";
import { listCustomReservedInventoryBucketTypes } from "./schema/reserved-inventory-buckets/list-custom-reserved-inventory-bucket-types";
import { updateCustomReservedInventoryBucketType } from "./schema/reserved-inventory-buckets/update-custom-reserved-inventory-bucket-type";
import { updateReservedInventoryBucket } from "./schema/reserved-inventory-buckets/update-reserved-inventory-bucket";

export const groupL: {
  bulkUpdateReservedInventoryBuckets: typeof bulkUpdateReservedInventoryBuckets;
  createCustomReservedInventoryBucketType: typeof createCustomReservedInventoryBucketType;
  createInventoryAdjustmentReason: typeof createInventoryAdjustmentReason;
  deleteCustomReservedInventoryBucketType: typeof deleteCustomReservedInventoryBucketType;
  deleteInventoryAdjustmentReason: typeof deleteInventoryAdjustmentReason;
  getReservedInventoryBuckets: typeof getReservedInventoryBuckets;
  listCustomReservedInventoryBucketTypes: typeof listCustomReservedInventoryBucketTypes;
  listInventoryAdjustmentReasons: typeof listInventoryAdjustmentReasons;
  updateCustomReservedInventoryBucketType: typeof updateCustomReservedInventoryBucketType;
  updateInventoryAdjustmentReason: typeof updateInventoryAdjustmentReason;
  updateReservedInventoryBucket: typeof updateReservedInventoryBucket;
} = {
  bulkUpdateReservedInventoryBuckets,
  createCustomReservedInventoryBucketType,
  createInventoryAdjustmentReason,
  deleteCustomReservedInventoryBucketType,
  deleteInventoryAdjustmentReason,
  getReservedInventoryBuckets,
  listCustomReservedInventoryBucketTypes,
  listInventoryAdjustmentReasons,
  updateCustomReservedInventoryBucketType,
  updateInventoryAdjustmentReason,
  updateReservedInventoryBucket,
};
